/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Card, Button, CardBody, CardHeader, UncontrolledTooltip, ButtonGroup } from 'reactstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import SweetAlert from "react-bootstrap-sweetalert";

export default function HostAcquirer(props) {
  const token = localStorage.token;
  const acquirerId = props.acquirerId;
  const acquirerName = props.acquirerName;
  const [acquirerHost, setAcquirerHost] = useState([]);
  const redirectPrefix = `/admin/acquirer/host/${acquirerId}/edit/`;
  const [alert, setAlert] = React.useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [rowIndex, setRowIndex] = useState(0);

  let paginationOption = {
    page: 1,
    alwaysShowAllBtns: true,
    override: true,
    showTotal: true,
    withFirstAndLast: false,
    onPageChange: (page) => {
      calculateRowIndex(page, currentPageSize);
    },
    sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
      <div className="dataTables_length" id="datatable-basic_length">
        <label>
          Show{" "}
          {
            <select
              name="datatable-basic_length"
              aria-controls="datatable-basic"
              className="form-control form-control-sm"
              onChange={(e) => {
                onSizePerPageChange(e.target.value);
                setCurrentPageSize(e.target.value);
                calculateRowIndex(currentPage, e.target.value);
              }}
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          }{" "}
      entries.
    </label>
      </div>
    ),
  }

  const calculateRowIndex = (currentPage, currentPageSize) => {
    setRowIndex((currentPage - 1) * currentPageSize);
  }

  useEffect(() => {
    getAllAquirer();
  }, [props.acquirerId]);

  const getAllAquirer = () => {
    const data = { page: 1, per_page: 100, acquirer_id: acquirerId, };
    fetch(`${process.env.REACT_APP_API_BASE_URL}/hosts`, {
      method: 'POST', // or 'PUT'
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        setAcquirerHost(data.response_data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const delateHost = (acquirer_host_id) => {
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/host/delete/${acquirer_host_id}`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        setSuccessAlert();
        getAllAquirer();
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const setSuccessAlert = () => {
    setAlert(
      <SweetAlert
        success
        showConfirm
        confirmBtnText="Ok"
        title="Acquirer Host deleted"
        onCancel={hideAlert}
        onConfirm={hideAlert}
      />
    )
  }

  const setQuestionAlert = (acquirer_host_id) => {
    setAlert(
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Yes"
        confirmBtnBsStyle="danger"
        title="Are you sure?"
        onConfirm={() => delateHost(acquirer_host_id)}
        onCancel={hideAlert}
        focusCancelBtn
      />
    )
  }

  const hideAlert = () => {
    setAlert(null);
  }
  return (
    <>
      {alert}
      <Card>
        <CardHeader>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3>List Acquirer ({acquirerName})</h3>
            <div style={{ textAlign: "right" }}>
              <Link className="btn btn-info" to={`/admin/acquirer/host/${acquirerId}/create`}>
                Add
              </Link>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <ToolkitProvider
            rowNumber={rowIndex}
            data={acquirerHost}
            keyField="acquirer_host_id"
            columns={[
              {
                dataField: "no",
                text: "#",
                sort: true,
                page: 1,
                formatter: (cell, row, index) => {
                  let currentRow = ++index;
                  return currentRow + rowIndex;
                }
              },
              {
                dataField: "acquirer_host_type",
                text: "Host Type",
                sort: true,
              },
              {
                dataField: "primary_ip",
                text: "IP",
                sort: true,
                formatter: (cell, row) => {
                  return (
                    <React.Fragment>
                      {row.primary_ip} <br />
                      {row.secondary_ip}
                    </React.Fragment>
                  )
                }
              },
              {
                dataField: "primary_port",
                text: "Port",
                sort: true,
                formatter: (cell, row) => {
                  return (
                    <React.Fragment>
                      {row.primary_port} <br />
                      {row.secondary_port}
                    </React.Fragment>
                  )
                }
              },
              {
                dataField: "primary_nii",
                text: "NII",
                sort: true,
                formatter: (cell, row) => {
                  return (
                    <React.Fragment>
                      {row.primary_nii} <br />
                      {row.secondary_nii}
                    </React.Fragment>
                  )
                }
              },
              {
                dataField: "", text: "", formatter: (cell, row, index) => {
                  return (
                    <ButtonGroup>
                      <Button>
                        <Link
                          to={redirectPrefix + row.acquirer_host_id}
                          id={"tooltip_" + row.acquirer_host_id}
                        >
                          <i className="fas fa-user-edit" />
                        </Link>
                      </Button>
                      <UncontrolledTooltip delay={0} target={"tooltip_" + row.acquirer_host_id}>
                        Edit
                            </UncontrolledTooltip>
                      <Button
                        id="btn-acquirer"
                        onClick={() => setQuestionAlert(row.acquirer_host_id)}
                      >
                        <i className="fas fa-trash" />
                      </Button>
                      <UncontrolledTooltip
                        delay={0}
                        placement="top"
                        target="btn-acquirer"
                      >
                        Delete Acquirer Host
                            </UncontrolledTooltip>
                    </ButtonGroup>
                  )
                }
              },
            ]}
          >
            {(props) => (
              <div className="py-4 table-responsive">
                <BootstrapTable
                  {...props.baseProps}
                  bootstrap4={true}
                  bordered={false}
                  pagination={paginationFactory({ ...paginationOption })}
                />
              </div>
            )}
          </ToolkitProvider>
        </CardBody>
      </Card>
    </>
  );
}
